import { Box, Heading, HStack, Stack, VStack } from '@chakra-ui/react';

import MarkdownRenderer from '@/components/ui/MarkdownRender/MarkdownRender';
import { EAgentSchemaType, TAgentMetadata } from '@/types/agents';

import CopyButton from '../CopyButton/CopyButton';

import CanvasWrapper from './CanvasWrapper/CanvasWrapper';
import EmptySuccessState from './EmptySuccessState/EmptySuccessState';
import ErrorView from './ErrorView/ErrorView';
import FileOutput from './FileOutput/FileOutput';
import ImageOutput from './ImageOutput/ImageOutput';

interface IResultCanvasProps {
  metadata: TAgentMetadata | null;
  isLoading: boolean;
  error: boolean;
  agentSchema: Record<string, { type: EAgentSchemaType, description: string }>;
}

const ResultCanvas = ({ metadata, isLoading, error, agentSchema }: IResultCanvasProps) => {
  const shouldShowEmptySuccessState = !isLoading && !error && Object.entries(metadata?.output ?? {}).length === 0;

  if (error) {
    return (
      <CanvasWrapper isLoading={isLoading} error={error}>
        <ErrorView />
      </CanvasWrapper>
    );
  }

  return (
    <CanvasWrapper isLoading={isLoading} error={error}>
      {shouldShowEmptySuccessState ? <EmptySuccessState /> : (
        <VStack gap={4} w="100%">
          {Object.entries(agentSchema).map(([outputKey, { type }]) => {
            if (type === EAgentSchemaType.IMAGE) {
              return <ImageOutput metadata={metadata} isLoading={isLoading} outputKey={outputKey} />;
            }
            if (type === EAgentSchemaType.FILE) {
              return <FileOutput metadata={metadata} isLoading={isLoading} outputKey={outputKey} />;
            }

            return (
              <VStack
                alignItems="flex-start"
                bg="white"
                borderColor="gray.200"
                shadow="sm"
                borderRadius={14}
                boxShadow="6px 6px 54px 0 rgba(0, 0, 0, 0.05);"
                w="100%"
                gap={8}
                p={6}
              >
                {!isLoading && !error && (
                  <Stack gap={4} w="100%">
                    {metadata?.output?.[outputKey] && (
                      <Box
                        border="1px solid"
                        borderColor="#E4E4E7"
                        borderRadius={4}
                        p={3}
                      >
                        <HStack justify="space-between" align="start" alignItems="center">
                          <Heading fontSize={18} fontWeight={600}>Final Post</Heading>
                          <CopyButton text={metadata?.output?.[outputKey] || ''} />
                        </HStack>
                        <MarkdownRenderer
                          content={metadata?.output?.[outputKey] || 'No response available'}
                        />
                      </Box>
                    )}
                  </Stack>
                )}
              </VStack>
            );
          })}
        </VStack>
      )}
    </CanvasWrapper>
  );
};

export default ResultCanvas;